import script from "./add-person-fail-table.vue?vue&type=script&lang=tsx&setup=true"
export * from "./add-person-fail-table.vue?vue&type=script&lang=tsx&setup=true"

import "./add-person-fail-table.vue?vue&type=style&index=0&id=73be5f23&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73be5f23"]])

export default __exports__